import { render } from "./SystemRibbons.vue?vue&type=template&id=5445a9b7&scoped=true"
import script from "./SystemRibbons.vue?vue&type=script&lang=js"
export * from "./SystemRibbons.vue?vue&type=script&lang=js"

import "./SystemRibbons.vue?vue&type=style&index=0&id=5445a9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5445a9b7"]])

export default __exports__